import { ANALYTICS_TYPES, MESSAGE_TYPES, NAVIGATION_TYPES } from '@/Common/Runtime/events';

interface IShareComponentData {
	appId: string;
	componentName: string;
}

const createNavigationAction = (data: App.IRoute, subType: string): App.IPayloadData<App.IRouteData> => ({
	type: MESSAGE_TYPES.NAVIGATION,
	data: {
		...data,
		subType,
		data: data.payload
	}
});

export const createNavigationStartAction = (data: App.IRoute): App.IPayloadData<App.IRouteData> =>
	createNavigationAction(data, NAVIGATION_TYPES.NAVIGATION_START);
export const createNavigationFinishAction = (data: App.IRoute): App.IPayloadData<App.IRouteData> =>
	createNavigationAction(data, NAVIGATION_TYPES.NAVIGATION_START);

export const createNotificationAction = (notification: App.INoty): App.IPayloadData<App.INoty> => ({
	type: MESSAGE_TYPES.NOTIFICATION,
	data: notification
});

export const createGoogleAnalyticsAction = (data: Analytics.IGAEvent): App.IPayloadData<Analytics.ITypedData> => ({
	type: MESSAGE_TYPES.ANALYTICS,
	data: {
		analyticsType: ANALYTICS_TYPES.GOOGLE_ANALYTICS,
		data
	}
});

export const createAnalyticsAction = (data: Analytics.IGAEvent): App.IPayloadData<Analytics.ITypedData> =>
	createGoogleAnalyticsAction(data);

export const createShareComponentAction = (data: IShareComponentData): App.IPayloadData<IShareComponentData> => ({
	type: MESSAGE_TYPES.SHARE_COMPONENT,
	data
});
